import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import * as moment from "moment";
import * as enums from "./enumerations";
import * as modelsGet from "./models/get";
import * as modelsStorage from "./models/storage";
import * as modelsCalendar from "./models/calendar";
import * as modelsEnv from "./models/environment";
import * as utils from "./utils/utils";
import * as utilsStorage from "./utils/localstorage";
import * as utilsConstants from "./utils/constants";
import * as utilsEnv from "./utils/environment";
import * as utilsViewMode from "./utils/viewmode";
import * as globals from "./globals";
import * as apiAccounts from "./api/accounts";
import * as apiSettings from "./api/settings";
import { HomeFlyout } from "./components/homeFlyout"
import { Search } from "./components/search";
import { AddressFlyout } from "./components/addressFlyout"
import { NotificationsFlyout } from "./components/notificationsFlyout"
import { MainHeader } from "./components/mainHeader";
import { Calendar } from "./components/calendar";
import { EventDialog } from "./components/calendar/eventDialog";
import { LockDialog } from "./components/calendar/LockDialog";
import { Popup, PopupAlign } from "./components/popup";
import { ContextMenu, MenuItem, Separator } from "./components/contextmenu/index";
import { CalendarGroupSettings } from "./pages/settings/calendargroups";
import { CalendarSettings } from "./pages/settings/calendars";
import { CementerySettings } from "./pages/settings/cementeries";
import { GraveTypeSettings } from "./pages/settings/gravetypes";
import { LabelSettings } from "./pages/settings/labels";
import { SubjectSettings } from "./pages/settings/subjects";
import { StatusSettings } from "./pages/settings/status";
import { DisplayTypeSettings } from "./pages/settings/displaytypes";
import { BurialMethodSettings } from "./pages/settings/burialmethods";
import { MourninghallSettings } from "./pages/settings/morninghalls";
import { PersonTypeSettings } from "./pages/settings/persontypes";
import { MorticianSettings } from "./pages/settings/morticians";
import { PastorSettings } from "./pages/settings/pastors";
import { DenominationSettings } from "./pages/settings/denominations";
import { UsergroupSettings } from "./pages/settings/usergroups";
import { UserSettings } from "./pages/settings/users";
import { ReportSettings } from "./pages/settings/reports";
import { ApiClientSettings } from "./pages/settings/apiclients";
import { NotificationSettings } from "./pages/settings/notifications/notifications";
import OtherSettings from "./pages/settings/others/others";
import { Help } from "./pages/settings/help";
import { UserProfileGeneral } from "./pages/userProfile/general/general";
import { UserProfileSecurity } from "./pages/userProfile/security/security";
import { UserProfileNotifications } from "./pages/userProfile/notifications/notifications";
import { UserProfile } from "./pages/userProfile";
import LoginPage from "./pages/login";
import { LicencePage } from "./pages/licence";
import { IQueryString } from "./models/environment";
import { ISelectedObjectId } from "./models/calendar";
import { getViewModeFromString } from "./utils/viewmode";
import { parseValue } from "./utils/utils";

interface IProperties
{
    match: any,
    location: any,
    history: any,
    staticContext: any
}

interface IState
{
    refresh?: boolean,
    selectedObject?: modelsCalendar.ISelectedObjectId,
    selectedDate?: moment.Moment,
    selectedCalendar?: number,
    selectedCalendarViewMode?: enums.CalendarViewMode,
    currentUser?: modelsGet.IUser,
    calendarGroups?: modelsGet.ICalendarGroup[],
    calendars?: modelsGet.ICalendar[],

    /**
     * Enthält die Anzahl aller Benachrichtigungen des momentan angemeldeten Benutzers.
     */
    notificationsCount?: number,

    licenceError?: string,

    isHomeOpen?: boolean,
    isSearchOpen?: boolean,
    isContactInformationOpen?: boolean,
    isNotificationsOpen?: boolean,
    isSettingsOpen?: boolean,
    isProfileOpen?: boolean
}

export default class Main extends React.Component<IProperties, IState>
{
    private _previousLocation: any = null;

    constructor(props: IProperties)
    {
        super(props);
        this.state = {
            refresh: false,
            isHomeOpen: false,
            isSearchOpen: false,
            isContactInformationOpen: false,
            isNotificationsOpen: false,
            isSettingsOpen: false,
            isProfileOpen: false
        };

        props.history.listen(location =>
        {
            if (location.pathname.indexOf("settings") < 0 && location.pathname.indexOf("users") < 0 && location.pathname.indexOf("event") < 0 && location.pathname.indexOf("lock") < 0)
            {
                var uri: uri.URI = new URI(utilsEnv.getHost(location.pathname + location.search));
                utilsStorage.saveCalendarTempData({
                    selectedObject: uri.getObject(),
                    selectedDate: uri.getSelectedDate().format(),
                    viewMode: uri.getViewMode(),
                    selected: uri.getSelectedCalendarId()
                });
            }
        });

        this.initAsync();
    }

    /**
     * Initialisiert diese Komponente indem alle benötigten Daten geladen werden.
     */
    private async initAsync()
    {
        // Angemeldeten Benutzer laden.
        var currentUser = await globals.getCurrentUserAsync();

        // Alle Kalender laden.
        var calendarGroups = await globals.getCalendarGroupsAsync();

        // Alle Kalender laden.
        var calendars = await globals.getCalendarsAsync();

        // Die Anzahl aller Benachrichtigungen des momentan angemeldeten Benutzers ermitteln.
        var notificationsCount: number = await apiAccounts.getCurrentUsersNotificationsCount();

        // Prüfen ob eine Lizenz vorhanden ist und wenn ja, ob diese auch gültig ist.
        var licence: modelsGet.ILicence;
        var licenceError: string;

        try
        {
            licence = await apiSettings.getLicence();
        }
        catch (e)
        {
            if (e.responseJSON != null)
            {
                licenceError = e.responseJSON.error;
            }
        }

        // Neuen State setzen.
        this.setState({
            currentUser: currentUser,
            calendarGroups: calendarGroups,
            calendars: calendars,
            notificationsCount: notificationsCount,
            licenceError: licenceError
        });
    }

    /**
     * Wird aufgerufen bevor die Komponente gerendert wird.
     * @param nextProps
     */
    componentWillUpdate(nextProps)
    {
        const { location } = this.props;

        // set previousLocation if props.location is not modal
        if (nextProps.history.action !== 'POP' && (!location.state || !location.state.modal))
        {
            this._previousLocation = this.props.location
        }
    }

    /**
     * Öffnet ein beliebiges Flyout.
     * @param flyout Das Flyout welches geöffnet werden soll.
     */
    private showFlyout(flyout: enums.FlyoutType)
    {
        var newState: IState = {};

        switch (flyout)
        {
            case enums.FlyoutType.home:
                newState.isHomeOpen = true;
                break;
            case enums.FlyoutType.search:
                newState.isSearchOpen = true;
                break;
            case enums.FlyoutType.contactInformation:
                newState.isContactInformationOpen = true;
                break;
            case enums.FlyoutType.notifications:
                newState.isNotificationsOpen = true;
                break;
            case enums.FlyoutType.settings:
                newState.isSettingsOpen = true;
                break;
            case enums.FlyoutType.profile:
                newState.isProfileOpen = true;
                break;
        }

        this.setState(newState);
    }

    /**
     * Schließt ein beliebiges Flyout.
     * @param flyout Das Flyout welches geschlossen werden soll.
     */
    private hideFlyout(flyout: enums.FlyoutType)
    {
        var newState: IState = {};

        switch (flyout)
        {
            case enums.FlyoutType.home:
                newState.isHomeOpen = false;
                break;
            case enums.FlyoutType.search:
                newState.isSearchOpen = false;
                break;
            case enums.FlyoutType.contactInformation:
                newState.isContactInformationOpen = false;
                break;
            case enums.FlyoutType.notifications:
                newState.isNotificationsOpen = false;
                break;
            case enums.FlyoutType.settings:
                newState.isSettingsOpen = false;
                break;
            case enums.FlyoutType.profile:
                newState.isProfileOpen = false;
                break;
        }

        this.setState(newState);
    }

    /**
     * Benutzer ausloggen.
     */
    public signout = (): void =>
    {
        apiAccounts.signout().done((data) =>
        {
            location.reload();
        });
    };

    /**
     * Wird aufgerufen, sobald man den Kalender wechselt (Im Home Flyout).
     * @param calendar Der Kalender der ausgewählt wurde.
     */
    private onCalendarChanged = (calendar: modelsGet.ICalendar) =>
    {
        this.setState({
            selectedObject: {
                type: enums.CalendarObjectType.calendar,
                id: calendar.id
            }
        });
    }

    /**
     * Wird aufgerufen, sobald man die Kalendergruppe wechselt (Im Home Flyout).
     * @param group Die Kalendergruppe die ausgewählt wurde.
     */
    private onCalendarGroupChanged = (group: modelsGet.ICalendarGroup) =>
    {
        this.setState({
            selectedObject: {
                type: enums.CalendarObjectType.calendarGroup,
                id: group.id
            }
        });
    }

    /**
     * Wird aufgerufen, sobald sich der Termin oder Sperren Dialog schließt.
     * @param refresh Angabe, ob die Ansicht aktualisiert werden soll.
     */
    private onEventOrLockDialogClosed = (refresh: boolean) =>
    {
        if (refresh)
        {
            this.setState({
                refresh: true
            }, () => this.setState({ refresh: false }));
        }
    }

    /**
     * Wird aufgerufen, wenn ein Termin außerhalb eines Flyouts geöffnet werden soll.
     * @param event Der Termin der geöffnet werden soll.
     */
    private onOpenEvent = (event: modelsGet.IEvent) =>
    {
        const { history } = this.props;
        const uri: uri.URI = new URI();
        const viewMode: enums.CalendarViewMode = uri.getViewMode();

        if (viewMode === enums.CalendarViewMode.planning)
        {
            history.push("/event/" + event.id.toString() + "?calendar=" + event.calendar_id, {
                modal: true
            });
        }
        else
        {
            history.push("/event/" + event.id.toString(), {
                modal: true
            });
        }
    }

    /**
     * Wird aufgerufen, wenn ein Termin außerhalb eines Flyouts geöffnet werden soll.
     * @param event Der Termin zu dem gesprungen werden soll.
     */
    private onGotoEvent = (event: modelsGet.IEvent) =>
    {
        const { history } = this.props;
        var uri: uri.URI = new URI();
        var selectedObject: modelsCalendar.ISelectedObjectId = uri.getObject();

        if (selectedObject.type === enums.CalendarObjectType.all)
        {
            uri = uri.setNewLocation({
                selectedObjectId: {
                    type: enums.CalendarObjectType.all,
                    id: -1
                },
                date: moment(event.starttime)
            });
        }
        else if (selectedObject.type === enums.CalendarObjectType.calendar)
        {
            uri = uri.setNewLocation({
                selectedObjectId: {
                    type: enums.CalendarObjectType.calendar,
                    id: event.calendar_id
                },
                date: moment(event.starttime)
            });
        }
        else
        {
            uri = uri.setNewLocation({
                selectedObjectId: {
                    type: enums.CalendarObjectType.calendarGroup,
                    id: event.calendar_group_id
                },
                date: moment(event.starttime)
            });
        }

        history.push(uri.hrefRelative());
    }

    /**
     * Wird aufgerufen, wenn sich die Anzahl der Benachrichtigungen ändert.
     */
    private onNotificationsCountChange = (): void =>
    {
        apiAccounts.getCurrentUsersNotificationsCount().then((count) =>
        {
            this.setState({
                notificationsCount: count
            });
        });
    }
        
    /**
     * Rendert den MainHeader.
     * @param route
     * @param queryString
     * @param selectedObject
     * @param viewMode
     * @param notificationsCount
     * @param optionalHeaderText
     */
    private renderHeader(route: uri.URI, queryString: IQueryString, selectedObject: ISelectedObjectId, viewMode: enums.CalendarViewMode, notificationsCount: number, optionalHeaderText: string = ""): JSX.Element
    {
        return (
            <MainHeader
                route={route}
                queryString={queryString}
                selectedObject={selectedObject}
                selectedViewMode={viewMode}
                notificationsCount={notificationsCount}
                optionalHeaderText={optionalHeaderText}
                onMenuClick={() => this.showFlyout(enums.FlyoutType.home)}
                onSearchClick={() => this.showFlyout(enums.FlyoutType.search)}
                onHelpClick={() => this.showFlyout(enums.FlyoutType.contactInformation)}
                onNotificationsClick={() => this.showFlyout(enums.FlyoutType.notifications)} />
        );
    }

    /**
     * Immer wenn die Route "/" angesprungen wird, wird diese Methode aufgerufen um
     * den Benutzer zu einer richtigen/funktionierenden Route weiterzuleiten.
     * @param route Die auslösende Route.
     */
    private renderRedirect = (route) =>
    {
        var { currentUser, calendars } = this.state;
        var today: moment.Moment = moment();
        var link: string[] = [];
        var search: string[] = [];

        var calendarStorage = utilsStorage.getJSON<modelsStorage.ICalendarStorage>(utilsConstants.STORAGE_KEYS.calendar, true);
        if (currentUser != null && calendarStorage != null && calendarStorage.selectedObject != null && calendarStorage.selectedObject.id != null)
        {
            link.push(calendarStorage.selectedObject.type);
            link.push(calendarStorage.selectedObject.id.toString());

            link.push(today.year().toString());
            link.push((today.month() + 1).toString());

            if (currentUser.settings.style && currentUser.settings.style.defaultCalendarView)
            {
                let viewMode = getViewModeFromString(currentUser.settings.style.defaultCalendarView);
                if (viewMode !== enums.CalendarViewMode.month)
                    link.push(today.date().toString());

                search.push(`viewMode=${currentUser.settings.style.defaultCalendarView}`);
            }
            else
            {
                if (calendarStorage.viewMode !== enums.CalendarViewMode.month)
                    link.push(today.date().toString());

                search.push(`viewMode=${utilsViewMode.getViewModeString(calendarStorage.viewMode)}`);
            }

            if (calendarStorage.selected > 0)
                search.push(`selected=${calendarStorage.selected}`);
        }
        else if (calendars != null)
        {
            link.push("c");
            link.push(calendars.first().id.toString());

            link.push(today.year().toString());
            link.push((today.month() + 1).toString());

            search.push(`viewMode=${utilsViewMode.getViewModeString(enums.CalendarViewMode.month)}`);
        }
        else
        {
            return null;
        }

        return <Redirect to={{
            pathname: "/" + link.join("/"),
            search: (search.length > 0) ? "?" + search.join("&") : ""
        }} />
    }
    
    /**
     * Rendert den Header und den Kalender Bereich.
     * @param route Die auslösende Route.
     */
    private renderHeaderAndCalendar = (route): JSX.Element[] =>
    {
        var {
            refresh,
            currentUser,
            calendarGroups,
            calendars,
            notificationsCount,
            licenceError
        } = this.state;

        if (currentUser != null)
        {
            if (licenceError != null)
            {
                return [
                    <Redirect to="/licence" />
                ];
            }

            var uri: uri.URI = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
            var queryString: modelsEnv.IQueryString = uri.getQueryString();
            var viewMode: enums.CalendarViewMode = uri.getViewMode();
            var selectedObject: modelsCalendar.ISelectedObjectId = uri.getObject();
            var selectedDate: moment.Moment = uri.getSelectedDate();

            // Prüfen ob ein Kalender ausgewählt ist. Es muss immer einer ausgewählt sein (außer bei der Planungsansicht).
            if (viewMode !== enums.CalendarViewMode.planning && (selectedObject.type === enums.CalendarObjectType.all || selectedObject.type === enums.CalendarObjectType.calendarGroup) && (queryString.selected == null || queryString.selected <= 0))
            {
                if (selectedObject.type === enums.CalendarObjectType.all)
                    uri.setSearch("selected", calendars.first().id.toString());
                else
                    uri.setSearch("selected", calendarGroups.where(c => c.id === selectedObject.id).first().calendars.first().calendar_id.toString());

                return [
                    <Redirect to={uri.hrefRelative()} />
                ];
            }

            // Wenn der Benutzer eine Kalenderansicht ansteuert die er nicht sehen darf, wird zu einer Ansicht gewechselt die
            // er sehen darf.
            if (currentUser.claims.forbidden_view_modes != null && currentUser.claims.forbidden_view_modes.length > 0 && currentUser.claims.forbidden_view_modes.contains(viewMode))
            {
                let viewModes: number[] = [0, 1, 2, 3, 4];
                let firstViewMode: number = viewModes.where(v => !currentUser.claims.forbidden_view_modes.contains(v)).first();
                let newUri: uri.URI;

                if (firstViewMode === enums.CalendarViewMode.planning)
                {
                    newUri = uri.setNewLocation({
                        selectedObjectId: {
                            type: enums.CalendarObjectType.calendarGroup,
                            id: calendarGroups.first().id
                        },
                        viewMode: firstViewMode
                    });
                }
                else
                {
                    newUri = uri.setNewLocation({
                        viewMode: firstViewMode
                    });
                }

                return [
                    <Redirect to={newUri.hrefRelative()} />
                ];
            }

            // Header Komponente einrichten.
            var comps: JSX.Element[] = [];
            comps.push(
                this.renderHeader(new URI(uri.href()), queryString, selectedObject, viewMode, notificationsCount)
            );

            // Kalender Komponente einrichten.
            comps.push(
                <Calendar
                    refresh={refresh}
                    route={() => new URI(uri.href())}
                    selectedObject={selectedObject}
                    selectedDate={selectedDate}
                    selectedCalendar={queryString.selected}
                    selectedViewMode={queryString.viewMode} />
            );

            // Komponenten rendern.
            return (comps);
        }

        return null;
    }

    /**
     * Rendert den Dialog für das erstellen oder bearbeiten von Terminen.
     * @param route Die auslösende Route.
     */
    private renderEventDialog = (route): JSX.Element =>
    {
        const isModal: boolean = route.location.state != null && route.location.state.modal;
        var {
            currentUser,
            calendarGroups,
            calendars
        } = this.state;

        // Prüfen ob der angemeldete Benutzer schon geladen wurde. Die anderen Daten müssen nicht geprüft werden.
        // Wenn der Benutzer fertig geladen ist, sind auch die anderen Daten fertig geladen.
        if (currentUser != null)
        {
            var uri: uri.URI;
            var currentUri: uri.URI;
            if (isModal)
            {
                uri = new URI(utilsEnv.getHost(this._previousLocation.pathname + this._previousLocation.search));
                currentUri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
            }
            else
            {
                uri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
                currentUri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
            }

            var queryString: modelsEnv.IQueryString = uri.getQueryString();
            var selectedObject: modelsCalendar.ISelectedObjectId = uri.getObject();
            var selectedDate: moment.Moment = uri.getSelectedDate();
            var eventId: number = (route.match.params.id != null) ? parseInt(route.match.params.id) : null;

            // Kalender Komponente einrichten.
            return (
                <EventDialog
                    route={() => new URI(uri.href())}
                    currentRoute={() => new URI(currentUri.href())}
                    history={route.history}
                    appointmentId={eventId}
                    selectedObject={selectedObject}
                    selectedDate={selectedDate}
                    selectedCalendar={queryString.selected}
                    isModal={isModal}
                    onClose={this.onEventOrLockDialogClosed} />
            );
        }

        return null;
    }

    /**
     * Rendert den Dialog für das erstellen oder bearbeiten von Sperren.
     * @param route Die auslösende Route.
     */
    private renderLockDialog = (route): JSX.Element =>
    {
        const isModal: boolean = route.location.state != null && route.location.state.modal;
        var {
            currentUser,
            calendarGroups,
            calendars
        } = this.state;

        // Prüfen ob der angemeldete Benutzer schon geladen wurde. Die anderen Daten müssen nicht geprüft werden.
        // Wenn der Benutzer fertig geladen ist, sind auch die anderen Daten fertig geladen.
        if (currentUser != null)
        {
            var uri: uri.URI;
            var currentUri: uri.URI;
            if (isModal)
            {
                uri = new URI(utilsEnv.getHost(this._previousLocation.pathname + this._previousLocation.search));
                currentUri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
            }
            else
            {
                uri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
                currentUri = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
            }

            var queryString: modelsEnv.IQueryString = uri.getQueryString();
            var currentQueryString = currentUri.search(true);
            var selectedObject: modelsCalendar.ISelectedObjectId = uri.getObject();
            var selectedDate: moment.Moment = uri.getSelectedDate();
            var lockId: number = (route.match.params.id != null) ? parseInt(route.match.params.id) : null;
            var lockSeries: boolean = (currentQueryString.series != null) ? parseValue<boolean>(currentQueryString.series) : false;

            // Kalender Komponente einrichten.
            return (
                <LockDialog
                    route={() => new URI(uri.href())}
                    currentRoute={() => new URI(currentUri.href())}
                    history={route.history}
                    blockId={lockId}
                    isSeries={lockSeries}
                    selectedObject={selectedObject}
                    selectedDate={selectedDate}
                    selectedCalendar={queryString.selected}
                    onClose={this.onEventOrLockDialogClosed} />
            );
        }

        return null;
    }

    ///**
    // * Rendert die Seite für das bearbeiten des Benutzerprofils.
    // * @param route Die auslösende Route.
    // */
    //private renderUserProfile = (route): JSX.Element[] =>
    //{
    //    var { notificationsCount } = this.state;
    //    var uri: uri.URI = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
    //    var userId: number = utils.parseValue(route.match.params.id);

    //    // Header Komponente einrichten.
    //    var comps: JSX.Element[] = [];
    //    comps.push(
    //        this.renderHeader(new URI(uri.href()), null, null, null, notificationsCount, "Mein Profil - Einstellungen")
    //    );

    //    comps.push(
    //        <UserProfile
    //            route={() => new URI(uri.href())}
    //            history={route.history}
    //            userId={userId}
    //            onNotificationsChange={this.onNotificationsCountChange} />
    //    );

    //    return comps;
    //}

    /**
     * Rendert eine Bereich der Einstellungen.
     * @param route Die auslösende Route.
     */
    private renderSettings = (route): JSX.Element[] =>
    {
        var { notificationsCount, currentUser } = this.state;
        var uri: uri.URI = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
        //var userId: number = utils.parseValue(route.match.params.id);

        if (currentUser == null)
            return null;

        // Header Komponente einrichten.
        var comps: JSX.Element[] = [];
        comps.push(
            this.renderHeader(new URI(uri.href()), null, null, null, notificationsCount, "Einstellungen")
        );

        switch (route.match.path)
        {
            case "/settings/calendargroups":
                {
                    if (currentUser.claims.can_see_setting_calendargroups)
                    {
                        comps.push(
                            <CalendarGroupSettings />
                        );
                    }
                }
                break;
            case "/settings/calendars":
                {
                    if (currentUser.claims.can_see_setting_calendars)
                    {
                        comps.push(
                            <CalendarSettings />
                        );
                    }
                }
                break;
            case "/settings/cementeries":
                {
                    if (currentUser.claims.can_see_setting_cementeries)
                    {
                        comps.push(
                            <CementerySettings />
                        );
                    }
                }
                break;
            case "/settings/displaytypes":
                {
                    if (currentUser.claims.can_see_setting_displaytypes)
                    {
                        comps.push(
                            <DisplayTypeSettings />
                        );
                    }
                }
                break;
            case "/settings/users":
                {
                    if (currentUser.claims.can_see_setting_users)
                    {
                        comps.push(
                            <UserSettings />
                        );
                    }
                }
                break;
            case "/settings/usergroups":
                {
                    if (currentUser.claims.can_see_setting_usergroups)
                    {
                        comps.push(
                            <UsergroupSettings />
                        );
                    }
                }
                break;
            case "/settings/morticians":
                {
                    if (currentUser.claims.can_see_setting_morticians)
                    {
                        comps.push(
                            <MorticianSettings />
                        );
                    }
                }
                break;
            case "/settings/subjects":
                {
                    if (currentUser.claims.can_see_setting_subjects)
                    {
                        comps.push(
                            <SubjectSettings />
                        );
                    }
                }
                break;
            case "/settings/pastors":
                {
                    if (currentUser.claims.can_see_setting_pastors)
                    {
                        comps.push(
                            <PastorSettings />
                        );
                    }
                }
                break;
            case "/settings/mourninghalls":
                {
                    if (currentUser.claims.can_see_setting_mourninghalls)
                    {
                        comps.push(
                            <MourninghallSettings />
                        );
                    }
                }
                break;
            case "/settings/labels":
                {
                    if (currentUser.claims.can_see_setting_labels)
                    {
                        comps.push(
                            <LabelSettings />
                        );
                    }
                }
                break;
            case "/settings/reports":
                {
                    if (currentUser.claims.can_see_setting_reports)
                    {
                        comps.push(
                            <ReportSettings />
                        );
                    }
                }
                break;
            case "/settings/denominations":
                {
                    if (currentUser.claims.can_see_setting_denominations)
                    {
                        comps.push(
                            <DenominationSettings />
                        );
                    }
                }
                break;
            case "/settings/gravetypes":
                {
                    if (currentUser.claims.can_see_setting_gravetypes)
                    {
                        comps.push(
                            <GraveTypeSettings />
                        );
                    }
                }
                break;
            case "/settings/burialmethods":
                {
                    if (currentUser.claims.can_see_setting_burialmethods)
                    {
                        comps.push(
                            <BurialMethodSettings />
                        );
                    }
                }
                break;
            case "/settings/status":
                {
                    if (currentUser.claims.can_see_setting_status)
                    {
                        comps.push(
                            <StatusSettings />
                        );
                    }
                }
                break;
            case "/settings/persontypes":
                {
                    if (currentUser.claims.can_see_setting_persontypes)
                    {
                        comps.push(
                            <PersonTypeSettings />
                        );
                    }
                }
                break;
            case "/settings/apiclients":
                {
                    if (currentUser.claims.can_see_setting_api)
                    {
                        comps.push(
                            <ApiClientSettings />
                        );
                    }
                }
                break;
            case "/settings/notifications":
                {
                    if (currentUser.claims.can_see_setting_notifications)
                    {
                        comps.push(
                            <NotificationSettings />
                        );
                    }
                }
                break;
            case "/settings/others":
                {
                    if (currentUser.claims.can_see_setting_others)
                    {
                        comps.push(
                            <OtherSettings />
                        );
                    }
                }
                break;
            case "/settings/help":
                {
                    if (currentUser.claims.can_see_setting_help)
                    {
                        comps.push(
                            <Help />
                        );
                    }
                }
                break;
        }

        return comps.length > 1 ? comps : [<Redirect to="/" />];
    }

    private renderUserProfile = (route): JSX.Element[] => {
        var { notificationsCount, currentUser } = this.state;
        var uri: uri.URI = new URI(utilsEnv.getHost(route.location.pathname + route.location.search));
        //var userId: number = utils.parseValue(route.match.params.id);

        if (currentUser == null)
            return null;

        // Header Komponente einrichten.
        var comps: JSX.Element[] = [];
        comps.push(
            this.renderHeader(new URI(uri.href()), null, null, null, notificationsCount, "Einstellungen")
        );

        switch (route.match.path) {
            case `/user/profile/general`:
                {
                    comps.push(
                        <UserProfileGeneral />
                    );
                }
                break;
            case `/user/profile/security`:
                {
                    comps.push(
                        <UserProfileSecurity />
                    );
                }
                break;
            case `/user/profile/notifications`:
                {
                    comps.push(
                        <UserProfileNotifications />
                    );
                }
                break;
        }

        return comps.length > 1 ? comps : [<Redirect to="/" />];
    }

    /**
     * Rendert die Seite um eine Lizenz zu registrieren.
     * @param route Die auslösende Route.
     */
    private renderLicence = (route): JSX.Element =>
    {
        return <LicencePage mode={this.state.licenceError as any} />;
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { location, history } = this.props
        const { currentUser, licenceError } = this.state
        const isModal = !!(
            location.state &&
            location.state.modal &&
            this._previousLocation !== location // not initial render
        );
        const uri: uri.URI = new URI(utilsEnv.getHost(location.pathname + location.search));

        return (
            <div className="app-container">
                <Switch location={isModal ? this._previousLocation : location}>
                    <Route path="/" exact component={this.renderRedirect} />
                    <Route path="/:objectType/:objectId/:year/:month" component={this.renderHeaderAndCalendar} />
                    <Route path="/:objectType/:objectId/:year/:month/:day" component={this.renderHeaderAndCalendar} />
                    <Route path="/settings/calendargroups" exact component={this.renderSettings} />
                    <Route path="/settings/calendars" exact component={this.renderSettings} />
                    <Route path="/settings/cementeries" exact component={this.renderSettings} />
                    <Route path="/settings/gravetypes" exact component={this.renderSettings} />
                    <Route path="/settings/labels" exact component={this.renderSettings} />
                    <Route path="/settings/subjects" exact component={this.renderSettings} />
                    <Route path="/settings/status" exact component={this.renderSettings} />
                    <Route path="/settings/displaytypes" exact component={this.renderSettings} />
                    <Route path="/settings/burialmethods" exact component={this.renderSettings} />
                    <Route path="/settings/mourninghalls" exact component={this.renderSettings} />
                    <Route path="/settings/persontypes" exact component={this.renderSettings} />
                    <Route path="/settings/morticians" exact component={this.renderSettings} />
                    <Route path="/settings/pastors" exact component={this.renderSettings} />
                    <Route path="/settings/denominations" exact component={this.renderSettings} />
                    <Route path="/settings/usergroups" exact component={this.renderSettings} />
                    <Route path="/settings/users" exact component={this.renderSettings} />
                    <Route path="/settings/reports" exact component={this.renderSettings} />
                    <Route path="/settings/apiclients" exact component={this.renderSettings} />
                    <Route path="/settings/notifications" exact component={this.renderSettings} />
                    <Route path="/settings/others" exact component={this.renderSettings} />
                    <Route path="/settings/help" exact component={this.renderSettings} />
                    <Route path="/user/profile/general" exact component={this.renderUserProfile} />
                    <Route path="/user/profile/security" exact component={this.renderUserProfile} />
                    <Route path="/user/profile/notifications" exact component={this.renderUserProfile} />
                    {
                        licenceError != null &&
                        <Route path="/licence" exact component={this.renderLicence} />
                    }
                    <Redirect to="/" />
                </Switch>
                {
                    isModal && 
                    <Switch location={location}>
                        <Route path="/event/new" exact component={this.renderEventDialog} />
                        <Route path="/event/:id" exact component={this.renderEventDialog} />
                        <Route path="/lock/new" exact component={this.renderLockDialog} />
                        <Route path="/lock/:id" exact component={this.renderLockDialog} />
                    </Switch>
                }
                <HomeFlyout
                    currentViewMode={uri.getViewMode()}
                    isOpen={this.state.isHomeOpen}
                    onCalendarItemClick={this.onCalendarChanged}
                    onCalendarGroupItemClick={this.onCalendarGroupChanged}
                    onClose={() => this.hideFlyout(enums.FlyoutType.home)} />
                <Search
                    show={this.state.isSearchOpen}
                    onOpenEvent={this.onOpenEvent}
                    onGotoEvent={this.onGotoEvent}
                    onClose={() => this.hideFlyout(enums.FlyoutType.search)} />
                <AddressFlyout
                    isOpen={this.state.isContactInformationOpen}
                    calendars={this.state.calendars}
                    onClose={() => this.hideFlyout(enums.FlyoutType.contactInformation)} />
                <NotificationsFlyout
                    route={() => new URI(uri.href())}
                    history={history}
                    isOpen={this.state.isNotificationsOpen}
                    onNotificationsChange={this.onNotificationsCountChange}
                    onClose={() => this.hideFlyout(enums.FlyoutType.notifications)} />
                {
                    currentUser != null &&
                    <Popup
                        id="settings-popup"
                        align={PopupAlign.targetNodeBottomRight}>
                        <ContextMenu>
                            <MenuItem
                                icon="calendar-multiple"
                                header="Kalendergruppen"
                                linkTo="/settings/calendargroups"
                                isDisabled={!currentUser.claims.can_see_setting_calendargroups} />
                            <MenuItem
                                icon="calendar"
                                header="Kalender"
                                linkTo="/settings/calendars"
                                isDisabled={!currentUser.claims.can_see_setting_calendars} />
                            <MenuItem
                                icon="church"
                                header="Friedhöfe"
                                linkTo="/settings/cementeries"
                                isDisabled={!currentUser.claims.can_see_setting_cementeries} />
                            <MenuItem
                                icon="layers"
                                header="Grabarten"
                                linkTo="/settings/gravetypes"
                                isDisabled={!currentUser.claims.can_see_setting_gravetypes} />
                            <Separator />
                            <MenuItem
                                icon="tag-multiple"
                                header="Labels"
                                linkTo="/settings/labels"
                                isDisabled={!currentUser.claims.can_see_setting_labels} />
                            <MenuItem
                                icon="calendar-text"
                                header="Betreffzeilen"
                                linkTo="/settings/subjects"
                                isDisabled={!currentUser.claims.can_see_setting_subjects} />
                            <MenuItem
                                icon="ray-start-arrow"
                                header="Status"
                                linkTo="/settings/status"
                                isDisabled={!currentUser.claims.can_see_setting_status} />
                            <MenuItem
                                icon="notebook"
                                header="Anzeigearten"
                                linkTo="/settings/displaytypes"
                                isDisabled={!currentUser.claims.can_see_setting_displaytypes} />
                            <MenuItem
                                icon="home-account"
                                header="Bestattungsarten"
                                linkTo="/settings/burialmethods"
                                isDisabled={!currentUser.claims.can_see_setting_burialmethods} />
                            <MenuItem
                                icon="home"
                                header="Trauerhallen"
                                linkTo="/settings/mourninghalls"
                                isDisabled={!currentUser.claims.can_see_setting_mourninghalls} />
                            <Separator />
                            <MenuItem
                                icon="account-settings"
                                header="Personenarten"
                                linkTo="/settings/persontypes"
                                isDisabled={!currentUser.claims.can_see_setting_persontypes} />
                            <MenuItem
                                icon="worker"
                                header="Bestatter"
                                linkTo="/settings/morticians"
                                isDisabled={!currentUser.claims.can_see_setting_morticians} />
                            <MenuItem
                                icon="worker"
                                header="Pfarrer"
                                linkTo="/settings/pastors"
                                isDisabled={!currentUser.claims.can_see_setting_pastors} />
                            <MenuItem
                                icon="clipboard-account"
                                header="Konfessionen"
                                linkTo="/settings/denominations"
                                isDisabled={!currentUser.claims.can_see_setting_denominations} />
                            <Separator />
                            <MenuItem
                                icon="account-multiple"
                                header="Benutzergruppen"
                                linkTo="/settings/usergroups"
                                isDisabled={!currentUser.claims.can_see_setting_usergroups} />
                            <MenuItem
                                icon="account"
                                header="Benutzer"
                                linkTo="/settings/users"
                                isDisabled={!currentUser.claims.can_see_setting_users} />
                            <Separator />
                            <MenuItem
                                icon="file-chart"
                                header="Reports"
                                linkTo="/settings/reports"
                                isDisabled={!currentUser.claims.can_see_setting_reports} />
                            <Separator />
                            <MenuItem
                                icon="cloud-outline"
                                header="API"
                                linkTo="/settings/apiclients"
                                isDisabled={!currentUser.claims.can_see_setting_api} />
                            <MenuItem
                                icon="comment-multiple"
                                header="Benachrichtigungen"
                                linkTo="/settings/notifications"
                                isDisabled={!currentUser.claims.can_see_setting_notifications} />
                            <MenuItem
                                icon="tune"
                                header="Sonstiges"
                                linkTo="/settings/others"
                                isDisabled={!currentUser.claims.can_see_setting_others} />
                            <Separator />
                            <MenuItem
                                icon="help-circle"
                                header="Hilfe"
                                linkTo="/settings/help"
                                isDisabled={!currentUser.claims.can_see_setting_help} />
                        </ContextMenu>
                    </Popup>
                }
                <Popup
                    id="profile-popup"
                    align={PopupAlign.targetNodeBottomRight}>
                    <ContextMenu>
                        <MenuItem
                            icon="account"
                            header="Profil"
                            linkTo="/user/profile/general" />
                        <MenuItem
                            icon="security"
                            header="Sicherheit"
                            linkTo="/user/profile/security" />
                        <Separator />
                        <MenuItem
                            icon="comment-multiple"
                            header="Benachrichtigungen"
                            linkTo="/user/profile/notifications" />
                        <Separator />
                        <MenuItem
                            icon="logout"
                            iconColor="red"
                            header="Abmelden"
                            onClick={this.signout} />                        
                    </ContextMenu>
                </Popup>
            </div>
        );
    }
}